import { render, staticRenderFns } from "./ConnectionScore.vue?vue&type=template&id=25c4c664&scoped=true&"
import script from "./ConnectionScore.vue?vue&type=script&lang=js&"
export * from "./ConnectionScore.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionScore.vue?vue&type=style&index=0&id=25c4c664&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c4c664",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VIcon,VSystemBar})
